<div
  class="dashboard-pg gp-dashboard grid-container"
  [ngClass]="{
    isHandset: breakPointService.isHandset$ | async,
    isTablet: breakPointService.isTablet$ | async
  }">
  <div
    class="dashboard-loading dashboard-layout"
    *ngIf="isGpDashboardLoading && !gpDashboardData"
    aria-busy="true"
    aria-live="polite"
    role="status">
    <span class="sr-only">Loading fund overview…</span>
    <div class="dashboard-skeleton-visual" aria-hidden="true">
      <main class="dashboard-content dashboard-skeleton-content">
        <header
          class="dashboard-header gp-dashboard-header dashboard-skeleton-header">
          <div class="dashboard-skeleton-header-copy">
            <span class="dashboard-skeleton dashboard-skeleton-eyebrow"></span>
            <span class="dashboard-skeleton dashboard-skeleton-title"></span>
            <span class="dashboard-skeleton dashboard-skeleton-subtitle"></span>
            <span class="dashboard-skeleton dashboard-skeleton-status"></span>
          </div>
          <span class="dashboard-skeleton dashboard-skeleton-button"></span>
        </header>

        <section class="dashboard-kpi-grid">
          <article
            class="dashboard-kpi-card dashboard-skeleton-kpi"
            *ngFor="let item of [1, 2, 3, 4]">
            <div class="dashboard-skeleton-kpi-top">
              <span class="dashboard-skeleton dashboard-skeleton-icon"></span>
              <span class="dashboard-skeleton dashboard-skeleton-label"></span>
            </div>
            <span class="dashboard-skeleton dashboard-skeleton-value"></span>
            <span class="dashboard-skeleton dashboard-skeleton-meta"></span>
            <span
              class="dashboard-skeleton dashboard-skeleton-sparkline"></span>
          </article>
        </section>

        <section
          class="dashboard-panel performance-panel dashboard-skeleton-panel">
          <div class="panel-header">
            <div class="panel-title-wrap">
              <span
                class="dashboard-skeleton dashboard-skeleton-panel-icon"></span>
              <div class="dashboard-skeleton-panel-copy">
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-title"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-subtitle"></span>
              </div>
            </div>
            <span class="dashboard-skeleton dashboard-skeleton-as-of"></span>
          </div>
          <div class="performance-stats dashboard-skeleton-stats">
            <div *ngFor="let item of [1, 2, 3, 4]">
              <span
                class="dashboard-skeleton dashboard-skeleton-stat-label"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-stat-value"></span>
            </div>
          </div>
          <div class="dashboard-skeleton-chart"></div>
        </section>

        <section class="dashboard-lower-grid">
          <article class="dashboard-panel dashboard-skeleton-panel">
            <div class="panel-header">
              <div class="panel-title-wrap">
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-icon"></span>
                <div class="dashboard-skeleton-panel-copy">
                  <span
                    class="dashboard-skeleton dashboard-skeleton-panel-title"></span>
                  <span
                    class="dashboard-skeleton dashboard-skeleton-panel-subtitle"></span>
                </div>
              </div>
              <span class="dashboard-skeleton dashboard-skeleton-count"></span>
            </div>
            <div class="dashboard-skeleton-list">
              <div
                class="dashboard-skeleton-list-item"
                *ngFor="let item of [1, 2, 3, 4]">
                <span
                  class="dashboard-skeleton dashboard-skeleton-marker"></span>
                <span class="dashboard-skeleton-list-copy">
                  <span
                    class="dashboard-skeleton dashboard-skeleton-list-title"></span>
                  <span
                    class="dashboard-skeleton dashboard-skeleton-list-subtitle"></span>
                </span>
              </div>
            </div>
          </article>

          <article class="dashboard-panel dashboard-skeleton-panel">
            <div class="panel-header">
              <div class="panel-title-wrap">
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-icon"></span>
                <div class="dashboard-skeleton-panel-copy">
                  <span
                    class="dashboard-skeleton dashboard-skeleton-panel-title"></span>
                  <span
                    class="dashboard-skeleton dashboard-skeleton-panel-subtitle"></span>
                </div>
              </div>
            </div>
            <div class="dashboard-skeleton-pipeline-stats">
              <div *ngFor="let item of [1, 2, 3]">
                <span
                  class="dashboard-skeleton dashboard-skeleton-pipeline-value"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-pipeline-label"></span>
              </div>
            </div>
            <div class="dashboard-skeleton-callout">
              <span
                class="dashboard-skeleton dashboard-skeleton-callout-icon"></span>
              <span class="dashboard-skeleton-list-copy">
                <span
                  class="dashboard-skeleton dashboard-skeleton-callout-title"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-callout-subtitle"></span>
              </span>
            </div>
          </article>
        </section>
      </main>

      <aside class="dashboard-priority-rail">
        <section class="dashboard-panel dashboard-skeleton-calendar">
          <div class="dashboard-skeleton-calendar-tabs">
            <span class="dashboard-skeleton dashboard-skeleton-tab"></span>
            <span class="dashboard-skeleton dashboard-skeleton-tab"></span>
          </div>
          <div class="dashboard-skeleton-calendar-heading">
            <span
              class="dashboard-skeleton dashboard-skeleton-month-button"></span>
            <span class="dashboard-skeleton dashboard-skeleton-month"></span>
            <span
              class="dashboard-skeleton dashboard-skeleton-month-button"></span>
          </div>
          <div class="dashboard-skeleton-calendar-grid">
            <span
              class="dashboard-skeleton dashboard-skeleton-day"
              *ngFor="
                let item of [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20, 21
                ]
              ">
            </span>
          </div>
          <div class="dashboard-skeleton-agenda">
            <span
              class="dashboard-skeleton dashboard-skeleton-agenda-item"
              *ngFor="let item of [1, 2, 3]"></span>
          </div>
        </section>

        <section
          class="dashboard-panel dashboard-skeleton-panel dashboard-skeleton-priorities">
          <div class="panel-header">
            <div class="dashboard-skeleton-panel-copy">
              <span
                class="dashboard-skeleton dashboard-skeleton-priority-title"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-priority-subtitle"></span>
            </div>
            <span class="dashboard-skeleton dashboard-skeleton-count"></span>
          </div>
          <div class="dashboard-skeleton-priority-list">
            <div
              class="dashboard-skeleton-priority-item"
              *ngFor="let item of [1, 2, 3]">
              <span
                class="dashboard-skeleton dashboard-skeleton-priority-icon"></span>
              <span class="dashboard-skeleton-list-copy">
                <span
                  class="dashboard-skeleton dashboard-skeleton-list-title"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-list-subtitle"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-priority-state"></span>
              </span>
            </div>
          </div>
        </section>

        <section class="dashboard-panel dashboard-skeleton-panel">
          <div class="panel-header">
            <div class="panel-title-wrap">
              <span
                class="dashboard-skeleton dashboard-skeleton-panel-icon"></span>
              <div class="dashboard-skeleton-panel-copy">
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-title"></span>
                <span
                  class="dashboard-skeleton dashboard-skeleton-panel-subtitle"></span>
              </div>
            </div>
            <span
              class="dashboard-skeleton dashboard-skeleton-team-link"></span>
          </div>
          <div class="dashboard-skeleton-team-list">
            <div
              class="dashboard-skeleton-team-item"
              *ngFor="let item of [1, 2, 3]">
              <span class="dashboard-skeleton dashboard-skeleton-avatar"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-team-name"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-team-count"></span>
            </div>
          </div>
        </section>
      </aside>
    </div>
  </div>

  <div
    class="dashboard-state dashboard-state-error"
    *ngIf="gpDashboardError && !isGpDashboardLoading">
    <div class="dashboard-state-icon"><mat-icon>cloud_off</mat-icon></div>
    <h2>Fund overview unavailable</h2>
    <p>We couldn't load the fund overview. Try again in a moment.</p>
    <button
      type="button"
      class="dashboard-outline-btn"
      (click)="getGpDashboardData(selectedVehicle?.id)">
      Retry
    </button>
  </div>

  <ng-container *ngIf="gpDashboardData as dashboard">
    <div class="dashboard-layout">
      <main class="dashboard-content">
        <header class="dashboard-header gp-dashboard-header">
          <div>
            <span class="dashboard-eyebrow">Portfolio overview</span>
            <h1 class="dashboard-title">Good Morning, {{ userName }}</h1>
            <p class="dashboard-subtitle">
              Here's what's happening with
              {{
                (gpDashboardData ? gpDashboardData.fund.name : null) ||
                  selectedVehicle?.name ||
                  'your fund'
              }}
              today.
            </p>
            <div class="dashboard-status-row">
              <span
                class="status-pill"
                [class.status-pill-muted]="
                  dashboard.performance.status !== 'HEALTHY'
                ">
                <span class="status-dot"></span>
                {{
                  dashboard.performance.status === 'HEALTHY'
                    ? 'Healthy'
                    : 'Awaiting data'
                }}
              </span>
              <span
                >Updated
                {{
                  formatDashboardDate(
                    dashboard.performance.approvedAt ||
                      dashboard.capitalPosition.asOf
                  )
                }}</span
              >
            </div>
          </div>
          <button
            type="button"
            class="refresh-dashboard-btn"
            (click)="getGpDashboardData(selectedVehicle?.id)"
            [disabled]="isGpDashboardLoading">
            <mat-icon>refresh</mat-icon>
            <span>{{ isGpDashboardLoading ? 'Refreshing' : 'Refresh' }}</span>
          </button>
        </header>

        <section
          class="dashboard-kpi-grid"
          aria-label="Fund key performance indicators">
          <article class="dashboard-kpi-card kpi-primary">
            <div class="kpi-card-top">
              <span class="kpi-icon"><mat-icon>bar_chart</mat-icon></span
              ><span>Net asset value</span>
            </div>
            <strong>{{
              formatDashboardMoney(
                dashboard.performance.netAssetValue,
                dashboard.performance.currency || dashboard.fund.currency
              )
            }}</strong>
            <span
              class="kpi-trend"
              *ngIf="dashboard.performance.comparisonPercent !== null"
              ><mat-icon>{{
                dashboard.performance.comparisonPercent >= 0
                  ? 'north_east'
                  : 'south_east'
              }}</mat-icon
              >{{ dashboard.performance.comparisonPercent >= 0 ? '+' : ''
              }}{{ dashboard.performance.comparisonPercent }}% vs previous
              period</span
            >
            <span
              class="kpi-muted"
              *ngIf="dashboard.performance.comparisonPercent === null"
              >Latest approved valuation</span
            >
            <svg
              class="kpi-sparkline"
              viewBox="0 0 180 32"
              preserveAspectRatio="none"
              aria-hidden="true"
              *ngIf="performanceSparklinePoints()">
              <polyline
                [attr.points]="performanceSparklinePoints()"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"></polyline>
            </svg>
          </article>

          <article class="dashboard-kpi-card kpi-green">
            <div class="kpi-card-top">
              <span class="kpi-icon"><mat-icon>groups</mat-icon></span
              ><span>Active investors</span>
            </div>
            <strong>{{ dashboard.investorActivity.activeInvestors }}</strong>
            <span
              class="kpi-trend"
              *ngIf="dashboard.investorActivity.pendingOnboardingReviews > 0"
              ><mat-icon>north_east</mat-icon
              >{{ dashboard.investorActivity.pendingOnboardingReviews }} pending
              review</span
            >
            <span
              class="kpi-muted"
              *ngIf="dashboard.investorActivity.pendingOnboardingReviews === 0"
              >Current investor base</span
            >
          </article>

          <article class="dashboard-kpi-card kpi-orange">
            <div class="kpi-card-top">
              <span class="kpi-icon"><mat-icon>account_balance</mat-icon></span
              ><span>Uncalled capital</span>
            </div>
            <strong>{{
              formatDashboardMoney(
                dashboard.capitalPosition.uncalled,
                dashboard.capitalPosition.currency || dashboard.fund.currency
              )
            }}</strong>
            <span
              class="kpi-warning"
              *ngIf="dashboard.capitalPosition.calledPercent !== null"
              >{{ 100 - dashboard.capitalPosition.calledPercent }}%
              remaining</span
            >
            <span
              class="kpi-muted"
              *ngIf="dashboard.capitalPosition.calledPercent === null"
              >Commitment data unavailable</span
            >
            <span
              class="kpi-footnote"
              *ngIf="dashboard.capitalPosition.committed"
              >Commitment
              {{
                formatDashboardMoney(
                  dashboard.capitalPosition.committed,
                  dashboard.capitalPosition.currency || dashboard.fund.currency
                )
              }}</span
            >
          </article>

          <article class="dashboard-kpi-card kpi-green">
            <div class="kpi-card-top">
              <span class="kpi-icon"><mat-icon>percent</mat-icon></span
              ><span>Collection rate</span>
            </div>
            <strong>{{ collectionRate(dashboard) }}</strong>
            <span
              class="kpi-trend"
              *ngIf="
                dashboard.capitalActivity.outstandingInvestors === 0 &&
                hasIssuedCapitalActivity(dashboard)
              "
              ><mat-icon>north_east</mat-icon>All issued calls collected</span
            >
            <span
              class="kpi-muted"
              *ngIf="dashboard.capitalActivity.outstandingInvestors > 0"
              >{{ dashboard.capitalActivity.outstandingInvestors }} investor{{
                dashboard.capitalActivity.outstandingInvestors === 1 ? '' : 's'
              }}
              outstanding</span
            >
            <span class="kpi-muted" *ngIf="!hasIssuedCapitalActivity(dashboard)"
              >No issued calls yet</span
            >
            <span class="kpi-footnote">Based on issued call activity</span>
          </article>
        </section>

        <section class="dashboard-panel performance-panel">
          <div class="panel-header">
            <div class="panel-title-wrap">
              <span class="panel-icon panel-icon-primary"
                ><mat-icon>bar_chart</mat-icon></span
              >
              <div>
                <h2>Fund performance</h2>
                <p>Approved valuation trend</p>
              </div>
            </div>
            <span class="panel-as-of" *ngIf="dashboard.performance.approvedAt"
              >Approved
              {{ formatDashboardDate(dashboard.performance.approvedAt) }}</span
            >
          </div>
          <div class="performance-stats">
            <div>
              <span>Net asset value</span
              ><strong>{{
                formatDashboardMoney(
                  dashboard.performance.netAssetValue,
                  dashboard.performance.currency || dashboard.fund.currency
                )
              }}</strong
              ><em *ngIf="dashboard.performance.comparisonPercent !== null"
                >{{ dashboard.performance.comparisonPercent >= 0 ? '+' : ''
                }}{{ dashboard.performance.comparisonPercent }}%</em
              >
            </div>
            <div>
              <span>Net IRR</span
              ><strong>{{
                dashboard.performance.netIrr
                  ? dashboard.performance.netIrr + '%'
                  : '—'
              }}</strong>
            </div>
            <div>
              <span>TVPI</span
              ><strong>{{
                dashboard.performance.tvpi
                  ? dashboard.performance.tvpi + 'x'
                  : '—'
              }}</strong>
            </div>
            <div>
              <span>DPI</span
              ><strong>{{
                dashboard.performance.dpi
                  ? dashboard.performance.dpi + 'x'
                  : '—'
              }}</strong>
            </div>
          </div>
          <div
            class="performance-chart"
            *ngIf="dashboard.performance.trend.length; else noPerformanceData">
            <div class="chart-y-axis">
              <span *ngFor="let label of performanceAxisLabels()">{{
                label
              }}</span>
            </div>
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              role="img"
              aria-label="Net asset value trend">
              <defs>
                <linearGradient
                  id="performance-fill"
                  x1="0"
                  x2="0"
                  y1="0"
                  y2="1">
                  <stop
                    offset="0"
                    stop-color="var(--primary-color, #003a29)"
                    stop-opacity=".22"></stop>
                  <stop
                    offset="1"
                    stop-color="var(--primary-color, #003a29)"
                    stop-opacity="0"></stop>
                </linearGradient>
              </defs>
              <line x1="0" y1="8" x2="100" y2="8" class="chart-gridline"></line>
              <line
                x1="0"
                y1="36"
                x2="100"
                y2="36"
                class="chart-gridline"></line>
              <line
                x1="0"
                y1="64"
                x2="100"
                y2="64"
                class="chart-gridline"></line>
              <line
                x1="0"
                y1="92"
                x2="100"
                y2="92"
                class="chart-gridline"></line>
              <polygon
                [attr.points]="performanceAreaPoints()"
                fill="url(#performance-fill)"></polygon>
              <polyline
                [attr.points]="performanceTrendPoints()"
                fill="none"
                stroke="var(--primary-color, #003a29)"
                stroke-width="1.8"
                vector-effect="non-scaling-stroke"
                stroke-linecap="round"
                stroke-linejoin="round"></polyline>
            </svg>
            <div class="chart-x-axis">
              <span *ngFor="let point of dashboard.performance.trend">{{
                formatPerformancePeriod(point.date)
              }}</span>
            </div>
          </div>
          <ng-template #noPerformanceData
            ><div class="panel-empty">
              <mat-icon>query_stats</mat-icon
              ><span>No approved performance periods yet.</span>
            </div></ng-template
          >
        </section>

        <section class="dashboard-lower-grid">
          <article class="dashboard-panel activity-panel">
            <div class="panel-header">
              <div class="panel-title-wrap">
                <span class="panel-icon panel-icon-orange"
                  ><mat-icon>monitor_heart</mat-icon></span
                >
                <div>
                  <h2>Fund activity</h2>
                  <p>Recent fund updates</p>
                </div>
              </div>
              <span class="panel-count" *ngIf="dashboardActivityData.length">{{
                dashboardActivityData.length
              }}</span>
            </div>
            <ng-container
              *ngIf="
                !isActivityLoading && !isActivityError;
                else activityState
              ">
              <div
                class="activity-list"
                *ngIf="dashboardActivityData.length; else noActivity">
                <div
                  class="activity-item"
                  *ngFor="let item of dashboardActivityData | slice : 0 : 5">
                  <span class="activity-marker"></span>
                  <div>
                    <strong>{{ item.title }}</strong>
                    <small>
                      {{ item.subtitle || formatFeedStatus(item.status) }}
                      <span *ngIf="item.priority"> · {{ item.priority }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #activityState>
              <div
                class="panel-empty compact"
                *ngIf="isActivityError; else activityLoading">
                <mat-icon>cloud_off</mat-icon>
                <span>Recent fund activity is unavailable.</span>
                <button
                  type="button"
                  class="dashboard-outline-btn"
                  (click)="retryFundActivity(dashboard.fund.id)">
                  Retry
                </button>
              </div>
            </ng-template>
            <ng-template #activityLoading>
              <div
                class="activity-list activity-skeleton-list"
                aria-busy="true"
                aria-label="Loading fund activity"
                role="status">
                <div
                  class="activity-skeleton-item"
                  *ngFor="let skeleton of [1, 2, 3, 4, 5]">
                  <ngx-skeleton-loader
                    class="activity-skeleton-marker"
                    appearance="circle"
                    [theme]="{
                      width: '8px',
                      height: '8px',
                      margin: '5px 0 0'
                    }">
                  </ngx-skeleton-loader>
                  <div class="activity-skeleton-copy">
                    <ngx-skeleton-loader
                      class="activity-skeleton-title"
                      appearance="line"
                      [theme]="{ width: '72%', height: '12px', margin: '0' }">
                    </ngx-skeleton-loader>
                    <ngx-skeleton-loader
                      class="activity-skeleton-subtitle"
                      appearance="line"
                      [theme]="{ width: '44%', height: '10px', margin: '0' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template #noActivity
              ><div class="panel-empty compact">
                <mat-icon>history</mat-icon><span>No recent activity.</span>
              </div></ng-template
            >
          </article>

          <article class="dashboard-panel pipeline-panel">
            <div class="panel-header">
              <div class="panel-title-wrap">
                <span class="panel-icon panel-icon-blue"
                  ><mat-icon>groups</mat-icon></span
                >
                <div>
                  <h2>Investor pipeline</h2>
                  <p>Fund-level investor activity</p>
                </div>
              </div>
            </div>
            <div class="pipeline-stats">
              <div>
                <strong>{{ dashboard.investorActivity.activeInvestors }}</strong
                ><span>Active investors</span>
              </div>
              <div>
                <strong>{{
                  dashboard.investorActivity.outstandingCapitalCalls
                }}</strong
                ><span>Outstanding calls</span>
              </div>
              <div>
                <strong>{{
                  dashboard.investorActivity.pendingOnboardingReviews
                }}</strong
                ><span>Reviews waiting</span>
              </div>
            </div>
            <div
              class="pipeline-callout"
              [class.pipeline-callout-positive]="
                dashboard.investorActivity.pendingOnboardingReviews === 0
              ">
              <mat-icon>{{
                dashboard.investorActivity.pendingOnboardingReviews === 0
                  ? 'check_circle'
                  : 'rate_review'
              }}</mat-icon>
              <div>
                <strong>{{
                  dashboard.investorActivity.pendingOnboardingReviews === 0
                    ? 'No investor reviews waiting'
                    : 'Investor reviews need attention'
                }}</strong
                ><span>{{
                  dashboard.investorActivity.pendingOnboardingReviews === 0
                    ? 'All up to date'
                    : 'Review submitted onboarding cases'
                }}</span>
              </div>
            </div>
          </article>
        </section>
      </main>

      <aside class="dashboard-priority-rail">
        <div class="dashboard-calendar-section">
          <app-dashboard-calendar-widget
            [events]="dashboardEventData"
            [news]="dashboardNewsData"
            [tasks]="dashboardTaskData"
            [updates]="filteredUpdates"
            [eventsLoaded]="isEventLoading"
            [newsLoaded]="isNewsLoading"
            [tasksLoaded]="isTaskLoading"
            [updatesLoaded]="isUpdateloaded"
            [eventsError]="isEventError"
            [newsError]="isNewsError"
            [tasksError]="isTaskError"
            [updatesError]="isUpdateError"
            [languageCode]="languageCode"
            (eventSelected)="iCalDownload($event)"
            (newsSelected)="goToLink($event.href)"
            (taskSelected)="openTask($event)"
            (updateSelected)="navigateUpdate($event)"
            (retryRequested)="
              retryCalendarData()
            "></app-dashboard-calendar-widget>
        </div>

        <section class="dashboard-priorities dashboard-panel">
          <div class="panel-header">
            <div>
              <h2>Today's priorities</h2>
              <p>
                {{ dashboard.decisions.totalCount }} item{{
                  dashboard.decisions.totalCount === 1 ? '' : 's'
                }}
                need{{ dashboard.decisions.totalCount === 1 ? 's' : '' }} your
                attention.
              </p>
            </div>
            <span class="priority-count">{{
              dashboard.decisions.items.length
            }}</span>
          </div>
          <div
            class="priority-list"
            *ngIf="dashboard.decisions.items.length; else noPriorities">
            <button
              type="button"
              class="priority-item"
              *ngFor="let decision of dashboard.decisions.items"
              (click)="openDashboardDecision(decision)"
              [disabled]="!isDashboardDecisionNavigable(decision)"
              [attr.aria-disabled]="
                !isDashboardDecisionNavigable(decision) ? 'true' : null
              ">
              <span class="priority-icon"
                ><mat-icon>{{ decisionIcon(decision.type) }}</mat-icon></span
              ><span class="priority-main"
                ><strong>{{ decision.title }}</strong
                ><small>{{ formatDecisionMetadata(decision.metadata) }}</small
                ><em [class.priority-risk]="decision.state === 'AT_RISK'">{{
                  formatDecisionState(decision.state)
                }}</em></span
              ><mat-icon
                class="priority-arrow"
                *ngIf="isDashboardDecisionNavigable(decision)"
                >chevron_right</mat-icon
              >
            </button>
          </div>
          <ng-template #noPriorities
            ><div class="panel-empty">
              <mat-icon>task_alt</mat-icon><strong>You're all caught up</strong
              ><span>No urgent fund actions right now.</span>
            </div></ng-template
          >
          <div class="deadline-list" *ngIf="dashboard.upcomingDeadlines.length">
            <h3>Upcoming deadlines</h3>
            <div
              class="deadline-item"
              *ngFor="let deadline of dashboard.upcomingDeadlines">
              <span class="deadline-date">{{
                formatDashboardDate(deadline.dueAt)
              }}</span
              ><span>{{ deadline.title }}</span>
            </div>
          </div>
        </section>

        <article
          class="dashboard-panel dashboard-team-rail"
          *ngIf="showTeamWidget">
          <div class="panel-header">
            <div class="dashboard-team-heading">
              <h2>Your ops team</h2>
              <p>
                {{ availableTeamCount }} of {{ teamMembers.length }} available
                now
              </p>
            </div>
          </div>
          <div
            class="dashboard-skeleton-team-list dashboard-team-skeleton"
            *ngIf="isTeamLoading; else teamState"
            aria-busy="true"
            aria-label="Loading team workload"
            role="status">
            <div
              class="dashboard-skeleton-team-item"
              *ngFor="let item of [1, 2, 3]">
              <span class="dashboard-skeleton dashboard-skeleton-avatar"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-team-name"></span>
              <span
                class="dashboard-skeleton dashboard-skeleton-team-count"></span>
            </div>
          </div>
          <ng-template #teamState>
            <div class="panel-empty compact" *ngIf="isTeamError; else teamList">
              <mat-icon>cloud_off</mat-icon>
              <span>Team workload is unavailable.</span>
              <button
                type="button"
                class="dashboard-outline-btn"
                (click)="getTeamMembers()">
                Retry
              </button>
            </div>
          </ng-template>
          <ng-template #teamList>
            <div
              class="team-workload-list"
              *ngIf="teamMembers.length; else noTeam">
              <button
                type="button"
                class="team-workload-item"
                *ngFor="let member of teamMembers | slice : 0 : 4"
                (click)="openTeammate(member)">
                <span class="team-workload-avatar-wrap">
                  <span class="team-workload-avatar"
                    ><img
                      *ngIf="member.avatarUrl"
                      [appAvatarImage]="member.avatarUrl"
                      [src]="member.avatarUrl"
                      [alt]="member | memberFullName" /><span
                      *ngIf="!member.avatarUrl"
                      >{{ member | memberInitials }}</span
                    ></span
                  >
                  <span
                    class="team-workload-presence"
                    [ngClass]="teamAvailabilityClass(member)"
                    aria-hidden="true"></span>
                </span>
                <span class="team-workload-main">
                  <span class="team-workload-name-row">
                    <strong>{{ member | memberFullName }}</strong>
                    <span
                      class="team-workload-status"
                      [ngClass]="teamAvailabilityClass(member)">
                      {{ teamAvailabilityLabel(member) }}
                    </span>
                  </span>
                  <span class="team-workload-role">{{
                    member.roles[0] | roleLabel
                  }}</span>
                  <span class="team-workload-email">{{ member.email }}</span>
                  <span class="team-workload-count">{{
                    activeTaskLabel(member)
                  }}</span>
                </span>
              </button>
            </div>
          </ng-template>
          <ng-template #noTeam
            ><div class="panel-empty compact">
              <mat-icon>group_off</mat-icon><span>No team workload yet.</span>
            </div></ng-template
          >
          <div class="dashboard-team-footer" *ngIf="teamMembers.length">
            <button
              type="button"
              class="dashboard-team-message-button"
              (click)="goToTeamChat()">
              <mat-icon>chat_bubble_outline</mat-icon>
              Message team
            </button>
          </div>
        </article>
      </aside>
    </div>
  </ng-container>
</div>
